// extracted by mini-css-extract-plugin
export var chevron = "_37-d";
export var disabled = "_37-b";
export var error = "_37-c";
export var hideBorder = "_37-1";
export var icon = "_37-e";
export var input = "_37-0";
export var large = "_37-f";
export var open = "_37-9";
export var placeholder = "_37-a";
export var regular = "_37-5";
export var singleRowInput = "_37-2";
export var singleSelectInput = "_37-3 _37-0";
export var small = "_37-4";
export var spinnerContainer = "_37-i";
export var tag = "_37-7";
export var tagsContainer = "_37-8";
export var tagsInput = "_37-6 _37-0";
export var xSmall = "_37-g";
export var xxSmall = "_37-h";